import { gql } from '@apollo/client';

export const CHECK_REPUBLISH_CONFLICT = gql`
    query CheckRepublishConflict(
        $taskDate: String!
        $warehouseId: Long!
        $areaIds: [Long!]!
    ) {
        checkRepublishConflict(
            taskDate: $taskDate
            warehouseId: $warehouseId
            areaIds: $areaIds
        ) {
            hasConflict
            scannedOrders {
                areaName
                trackingNumber
                stopNumber
            }
        }
    }
`;

export interface ScannedOrderInfo {
    areaName: string | null;
    trackingNumber: string;
    stopNumber: number;
}

export interface RepublishConflictStatus {
    hasConflict: boolean;
    scannedOrders: ScannedOrderInfo[];
}

export interface CheckRepublishConflictResponse {
    checkRepublishConflict: RepublishConflictStatus;
}

export interface CheckRepublishConflictVariables {
    taskDate: string;
    warehouseId: number;
    areaIds: number[];
}
